import { Instagram, Youtube } from "lucide-react";

const LOGOS = [
  "https://customer-assets-jt897jd0.emergentagent.net/job_adb5decd-5900-4816-abd1-ea444c906724/artifacts/04vpxw1y_image1%20%281%29.png",
  "https://customer-assets-jt897jd0.emergentagent.net/job_adb5decd-5900-4816-abd1-ea444c906724/artifacts/93u8qr5f_image2.png",
  "https://customer-assets-jt897jd0.emergentagent.net/job_adb5decd-5900-4816-abd1-ea444c906724/artifacts/nka4jjsn_image0%20%282%29.png",
];

const SOCIALS = [
  { icon: Instagram, label: "@vlmagonline", id: "vlmagonline", href: "https://www.instagram.com/vlmagonline" },
  { icon: Instagram, label: "@vlmagmusic", id: "vlmagmusic", href: "https://www.instagram.com/vlmagmusic" },
  { icon: Instagram, label: "@vlmagstyle", id: "vlmagstyle", href: "https://www.instagram.com/vlmagstyle" },
  { icon: Youtube, label: "YouTube", id: "youtube", href: "https://www.youtube.com/@VLMAGONLINE" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-black">
    <div className="px-5 md:px-10 py-16 md:py-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
        <div className="md:col-span-6">
          <h2 className="font-display uppercase leading-[0.85] tracking-tighter text-6xl md:text-8xl">
            <span className="text-[#E30613]">VL</span>
            <span className="text-white">MAG</span>
          </h2>
          <p className="font-serif-ed italic text-xl md:text-2xl text-neutral-300 mt-4 max-w-md">
            One creative media network — built to document, support and elevate what comes next.
          </p>
          <div className="flex flex-wrap gap-3 mt-8" data-testid="footer-socials">
            {SOCIALS.map((s) => (
              <a
                key={s.id}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={`social-${s.id}`}
                className="group inline-flex items-center gap-2.5 border border-white/20 px-4 h-12 text-neutral-400 hover:bg-[#E30613] hover:border-[#E30613] hover:text-white transition-colors duration-300"
              >
                <s.icon size={18} />
                <span className="text-[11px] uppercase tracking-[0.18em] font-bold">{s.label}</span>
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-neutral-600 mb-5">The Networks</p>
          <ul className="space-y-3">
            {[["VLMAG", "#vlmag"], ["VLMAG MUSIC", "#music"], ["VLMAG STYLE", "#style"]].map(([l, h]) => (
              <li key={l}>
                <a href={h} className="text-neutral-300 hover:text-[#E30613] transition-colors uppercase text-sm tracking-wide font-bold">{l}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-neutral-600 mb-5">Explore</p>
          <ul className="space-y-3">
            {[["Manifesto", "#manifesto"], ["Stories", "#stories"], ["Get Featured", "#featured"]].map(([l, h]) => (
              <li key={l}>
                <a href={h} className="text-neutral-300 hover:text-[#E30613] transition-colors text-sm tracking-wide">{l}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-6 md:gap-10 mt-16 pt-10 border-t border-white/10">
        {LOGOS.map((src, i) => (
          <img key={i} src={src} alt="VLMAG network" className="h-14 md:h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity" />
        ))}
      </div>

      <p className="text-[10px] uppercase tracking-[0.2em] text-neutral-600 mt-12">
        © {new Date().getFullYear()} VLMAG. Vision. Culture. Progress.
      </p>
    </div>
  </footer>
);
